module.exports = __webpack_public_path__ + "img/f-7-2.d4ce7167.png";